import { handleActions, Action } from 'redux-actions'
import {
  signinSuccess,
  signoutSuccess,
  unauthorize,
  fetchAppStateSuccess,
  showLoading,
  hideLoading,
  updateUser,
  updateEnableExecution,
} from './actions'

const loggedIn = handleActions(
  {
    [signinSuccess.toString()](state: boolean): boolean {
      return true
    },
    [signoutSuccess.toString()](state: boolean): boolean {
      return false
    },
    [unauthorize.toString()](state: boolean): boolean {
      return false
    }
  },
  false
)

const rootInitialState: IRootInfo = {
  appInfo: {},
  userInfo: {},
  orderInfo: {
    lineOrderInfoList: []
  },
}

const root = handleActions<IRootInfo, any>(
  {
    [fetchAppStateSuccess.toString()](state: IRootInfo, action: Action<IRootInfo>) {
      return { ...action.payload } as IRootInfo
    },
    [updateUser.toString()](state: IRootInfo, action: Action<IUser>) {
      return Object.assign({}, state, { userInfo: { ...action.payload } })
    },
    [signoutSuccess.toString()](state: IRootInfo, action: Action<void>) {
      return rootInitialState
    },
    [updateEnableExecution.toString()](state: IRootInfo, action: Action<boolean>) {
      return Object.assign({}, state, { enableExecution: action.payload })
    },
    [showLoading.toString()](state: IRootInfo, action: any) {
      return Object.assign({}, state, { loading: true })
    },
    [hideLoading.toString()](state: IRootInfo, action: any) {
      return Object.assign({}, state, { loading: false })
    }
  },
  rootInitialState
)

export default {
  loggedIn,
  root,
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/reducers.ts